import apiClient from './apiClient';
import { GET_CURRENCIES_URL } from './apiUrl';

const getCurrenciesApi = () => {
  return apiClient.get(GET_CURRENCIES_URL);
};

export default getCurrenciesApi;
